/**
 * This is server side shim of the editor, we use storage in editor to
 * provide helpers etc that extensions etc use. When we render on server
 * we don't have full instance of editor so we use this to provide the
 * things we need to render stuff.
 */
class SsrEditor {
  storage = {};

  setupEditor(externalRenderers) {
    this.storage['da-ext-renderers'] = externalRenderers;
  }
}

export default new SsrEditor();
